import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
const steps = [['01', 'Primera reunión', 'Escucho tu idea, necesidades y presupuesto'], ['02', 'Relevamiento', 'Analizo el espacio, medidas y posibilidades'], ['03', 'Anteproyecto', 'Presento ideas, renders y distribución inicial'], ['04', 'Proyecto definitivo', 'Planos, documentación y detalles técnicos'], ['05', 'Dirección de obra', 'Acompaño la ejecución hasta el resultado final']];
const testimonials = [['“María Victoria entendió cómo queríamos vivir antes de que pudiéramos explicarlo. El resultado es una casa luminosa y muy nuestra.”', 'Mariana y Tomás', 'Casa Loma'], ['“Una reforma compleja se convirtió en un proceso claro y disfrutable. Cada detalle fue pensado con enorme sensibilidad.”', 'Andrea F.', 'Apartamento R'], ['“Nos ayudó a construir una identidad para el café que se siente desde que cruzás la puerta.”', 'Santiago R.', 'Café Nido']];
export function ProcessTestimonials() {
  return <>
      <section id="proceso" className="bg-[#1A1A1A] px-5 py-24 text-white md:px-10 lg:py-32" data-id="element-136">
        <div className="mx-auto max-w-[1440px]" data-id="element-137">
          <p className="text-sm font-bold uppercase tracking-[.18em] text-[#d88b67] md:text-base" data-id="element-138">
            Cómo trabajo
          </p>
          <h2 className="font-editorial mt-5 max-w-xl text-4xl leading-tight md:text-5xl" data-id="element-139">
            Un proceso claro, de principio a fin
          </h2>
          <div className="relative mt-14" data-id="element-140">
            <div className="absolute left-5 right-5 top-5 hidden h-px bg-white/20 md:block" data-id="element-141" />
            <div className="grid gap-4 md:grid-cols-5 md:gap-5" data-id="element-142">
              {steps.map(([n, title, text], i) => <motion.article initial={{
              opacity: 0,
              y: 18
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.08,
              duration: 0.45
            }} key={n} className="relative border border-white/15 bg-white/[0.035] p-6 md:border-0 md:bg-transparent md:px-0 md:pt-0" data-id="element-143">
                  <div className="relative z-10 flex h-10 w-10 items-center justify-center rounded-full border border-[#C4724A] bg-[#1A1A1A] font-editorial text-sm text-[#e9c8b6]" data-id="element-144">
                    {n}
                  </div>
                  <div className="mt-7 h-px w-9 bg-[#C4724A] md:hidden" data-id="element-145" />
                  <h3 className="mt-5 text-sm font-bold tracking-[0.01em] text-white" data-id="element-146">
                    {title}
                  </h3>
                  <p className="mt-3 max-w-[210px] text-sm leading-6 text-white/60" data-id="element-147">
                    {text}
                  </p>
                </motion.article>)}
            </div>
          </div>
        </div>
      </section>
      <section className="bg-white px-5 py-24 md:px-10 lg:py-32" data-id="element-148">
        <div className="mx-auto max-w-[1440px]" data-id="element-149">
          <p className="text-[11px] font-bold uppercase tracking-[.2em] text-[#C4724A]" data-id="element-150">
            Lo que dicen
          </p>
          <h2 className="font-editorial mt-5 text-4xl md:text-5xl" data-id="element-151">
            Clientes que confiaron en el proceso
          </h2>
          <div className="mt-12 grid gap-5 lg:grid-cols-3" data-id="element-152">
            {testimonials.map(([quote, name, type]) => <article key={name} className="border border-[#e6e0d8] p-7 shadow-[0_12px_30px_rgba(45,36,25,.05)]" data-id="element-153">
                <QuoteIcon className="text-[#C4724A]" size={26} data-id="element-154" />
                <div className="mt-5 flex gap-1 text-[#C4724A]" data-id="element-155">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} size={13} fill="currentColor" data-id="element-156" />)}
                </div>
                <p className="font-editorial mt-5 text-xl leading-relaxed" data-id="element-157">
                  {quote}
                </p>
                <div className="mt-8 border-t border-[#eeeae4] pt-4" data-id="element-158">
                  <p className="text-sm font-bold" data-id="element-159">{name}</p>
                  <p className="mt-1 text-[10px] uppercase tracking-wider text-[#716a61]" data-id="element-160">
                    {type}
                  </p>
                </div>
              </article>)}
          </div>
        </div>
      </section>
    </>;
}